import { render, staticRenderFns } from "./Basic_Info.vue?vue&type=template&id=4f004ceb&"
import script from "./Basic_Info.vue?vue&type=script&lang=js&"
export * from "./Basic_Info.vue?vue&type=script&lang=js&"
import style0 from "./Basic_Info.vue?vue&type=style&index=0&id=4f004ceb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports